import type { PropsWithChildren } from "react";
import { RenderContext } from "../contexts/RenderContext";

export interface RenderProviderProps extends PropsWithChildren {
  value: {
    context: "editor" | "renderer";
    renderMedium: "screen" | "print";
    apiUrl: string;
  };
}

export const RenderProvider = ({ children, value }: RenderProviderProps) => {
  return (
    <RenderContext.Provider value={value}>{children}</RenderContext.Provider>
  );
};
